// Auto-generated file for DSO image imports

import ic1805 from '../../assets/dso/images/ic1805.jpg';
import ic2391 from '../../assets/dso/images/ic2391.png';
import ic2574 from '../../assets/dso/images/ic2574.jpg';
import ic2602 from '../../assets/dso/images/ic2602.jpeg';
import ic342 from '../../assets/dso/images/ic342.png';
import ic434 from '../../assets/dso/images/ic434.jpg';
import lmc from '../../assets/dso/images/lmc.jpg';
import m1 from '../../assets/dso/images/m1.png';
import m10 from '../../assets/dso/images/m10.png';
import m100 from '../../assets/dso/images/m100.jpg';
import m101 from '../../assets/dso/images/m101.jpg';
import m102 from '../../assets/dso/images/m102.png';
import m103 from '../../assets/dso/images/m103.jpg';
import m104 from '../../assets/dso/images/m104.jpeg';
import m105 from '../../assets/dso/images/m105.jpg';
import m106 from '../../assets/dso/images/m106.jpg';
import m107 from '../../assets/dso/images/m107.jpg';
import m108 from '../../assets/dso/images/m108.jpg';
import m109 from '../../assets/dso/images/m109.jpg';
import m11 from '../../assets/dso/images/m11.jpg';
import m110 from '../../assets/dso/images/m110.jpg';
import m12 from '../../assets/dso/images/m12.jpg';
import m13 from '../../assets/dso/images/m13.jpg';
import m14 from '../../assets/dso/images/m14.jpg';
import m15 from '../../assets/dso/images/m15.jpg';
import m16 from '../../assets/dso/images/m16.jpg';
import m17 from '../../assets/dso/images/m17.jpg';
import m19 from '../../assets/dso/images/m19.jpg';
import m2 from '../../assets/dso/images/m2.jpg';
import m20 from '../../assets/dso/images/m20.jpg';
import m21 from '../../assets/dso/images/m21.jpg';
import m22 from '../../assets/dso/images/m22.jpg';
import m23 from '../../assets/dso/images/m23.jpg';
import m24 from '../../assets/dso/images/m24.jpg';
import m25 from '../../assets/dso/images/m25.jpg';
import m26 from '../../assets/dso/images/m26.jpg';
import m27 from '../../assets/dso/images/m27.png';
import m28 from '../../assets/dso/images/m28.jpg';
import m29 from '../../assets/dso/images/m29.jpg';
import m3 from '../../assets/dso/images/m3.jpg';
import m30 from '../../assets/dso/images/m30.jpg';
import m31 from '../../assets/dso/images/m31.jpg';
import m32 from '../../assets/dso/images/m32.jpg';
import m33 from '../../assets/dso/images/m33.jpg';
import m34 from '../../assets/dso/images/m34.jpg';
import m35 from '../../assets/dso/images/m35.jpg';
import m36 from '../../assets/dso/images/m36.jpg';
import m37 from '../../assets/dso/images/m37.jpg';
import m38 from '../../assets/dso/images/m38.jpg';
import m39 from '../../assets/dso/images/m39.jpg';
import m4 from '../../assets/dso/images/m4.jpg';
import m41 from '../../assets/dso/images/m41.jpg';
import m42 from '../../assets/dso/images/m42.jpg';
import m44 from '../../assets/dso/images/m44.jpg';
import m45 from '../../assets/dso/images/m45.jpg';
import m46 from '../../assets/dso/images/m46.png';
import m47 from '../../assets/dso/images/m47.png';
import m48 from '../../assets/dso/images/m48.jpg';
import m49 from '../../assets/dso/images/m49.jpg';
import m5 from '../../assets/dso/images/m5.jpg';
import m50 from '../../assets/dso/images/m50.jpg';
import m51 from '../../assets/dso/images/m51.jpg';
import m52 from '../../assets/dso/images/m52.png';
import m53 from '../../assets/dso/images/m53.jpg';
import m55 from '../../assets/dso/images/m55.png';
import m56 from '../../assets/dso/images/m56.jpg';
import m57 from '../../assets/dso/images/m57.jpg';
import m59 from '../../assets/dso/images/m59.jpg';
import m6 from '../../assets/dso/images/m6.png';
import m60 from '../../assets/dso/images/m60.jpg';
import m61 from '../../assets/dso/images/m61.jpg';
import m62 from '../../assets/dso/images/m62.jpg';
import m63 from '../../assets/dso/images/m63.jpg';
import m64 from '../../assets/dso/images/m64.jpg';
import m65 from '../../assets/dso/images/m65.png';
import m66 from '../../assets/dso/images/m66.jpg';
import m67 from '../../assets/dso/images/m67.jpg';
import m68 from '../../assets/dso/images/m68.jpg';
import m69 from '../../assets/dso/images/m69.jpg';
import m7 from '../../assets/dso/images/m7.png';
import m70 from '../../assets/dso/images/m70.jpg';
import m71 from '../../assets/dso/images/m71.jpg';
import m72 from '../../assets/dso/images/m72.jpg';
import m74 from '../../assets/dso/images/m74.jpg';
import m75 from '../../assets/dso/images/m75.png';
import m76 from '../../assets/dso/images/m76.jpg';
import m77 from '../../assets/dso/images/m77.png';
import m78 from '../../assets/dso/images/m78.jpg';
import m79 from '../../assets/dso/images/m79.jpg';
import m8 from '../../assets/dso/images/m8.jpg';
import m80 from '../../assets/dso/images/m80.jpg';
import m81 from '../../assets/dso/images/m81.jpg';
import m82 from '../../assets/dso/images/m82.jpeg';
import m83 from '../../assets/dso/images/m83.jpg';
import m84 from '../../assets/dso/images/m84.jpg';
import m85 from '../../assets/dso/images/m85.jpg';
import m86 from '../../assets/dso/images/m86.jpg';
import m87 from '../../assets/dso/images/m87.jpg';
import m89 from '../../assets/dso/images/m89.jpg';
import m9 from '../../assets/dso/images/m9.jpg';
import m90 from '../../assets/dso/images/m90.jpg';
import m91 from '../../assets/dso/images/m91.jpg';
import m92 from '../../assets/dso/images/m92.jpg';
import m93 from '../../assets/dso/images/m93.jpg';
import m95 from '../../assets/dso/images/m95.jpg';
import m96 from '../../assets/dso/images/m96.jpg';
import m97 from '../../assets/dso/images/m97.jpg';
import m99 from '../../assets/dso/images/m99.jpg';
import markarians_chain from '../../assets/dso/images/markarians_chain.jpg';
import ngc104 from '../../assets/dso/images/ngc104.jpg';
import ngc1073 from '../../assets/dso/images/ngc1073.jpg';
import ngc1275 from '../../assets/dso/images/ngc1275.jpg';
import ngc1499 from '../../assets/dso/images/ngc1499.png';
import ngc1851 from '../../assets/dso/images/ngc1851.jpeg';
import ngc188 from '../../assets/dso/images/ngc188.jpg';
import ngc1931 from '../../assets/dso/images/ngc1931.jpg';
import ngc2070 from '../../assets/dso/images/ngc2070.png';
import ngc2169 from '../../assets/dso/images/ngc2169.jpg';
import ngc2237 from '../../assets/dso/images/ngc2237.jpg';
import ngc2261 from '../../assets/dso/images/ngc2261.jpg';
import ngc2264 from '../../assets/dso/images/ngc2264.jpg';
import ngc2301 from '../../assets/dso/images/ngc2301.jpg';
import ngc2359 from '../../assets/dso/images/ngc2359.jpg';
import ngc2362 from '../../assets/dso/images/ngc2362.jpg';
import ngc2392 from '../../assets/dso/images/ngc2392.jpg';
import ngc2403 from '../../assets/dso/images/ngc2403.jpg';
import ngc2419 from '../../assets/dso/images/ngc2419.jpg';
import ngc2438 from '../../assets/dso/images/ngc2438.jpg';
import ngc2440 from '../../assets/dso/images/ngc2440.png';
import ngc2451 from '../../assets/dso/images/ngc2451.jpg';
import ngc2477 from '../../assets/dso/images/ngc2477.jpg';
import ngc2516 from '../../assets/dso/images/ngc2516.jpg';
import ngc2683 from '../../assets/dso/images/ngc2683.jpg';
import ngc281 from '../../assets/dso/images/ngc281.jpg';
import ngc2841 from '../../assets/dso/images/ngc2841.jpg';
import ngc288 from '../../assets/dso/images/ngc288.jpg';
import ngc300 from '../../assets/dso/images/ngc300.jpg';
import ngc3132 from '../../assets/dso/images/ngc3132.png';
import ngc3184 from '../../assets/dso/images/ngc3184.jpg';
import ngc3293 from '../../assets/dso/images/ngc3293.jpg';
import ngc3310 from '../../assets/dso/images/ngc3310.jpg';
import ngc3372 from '../../assets/dso/images/ngc3372.jpg';
import ngc3521 from '../../assets/dso/images/ngc3521.jpg';
import ngc3532 from '../../assets/dso/images/ngc3532.png';
import ngc3576 from '../../assets/dso/images/ngc3576.jpg';
import ngc3603 from '../../assets/dso/images/ngc3603.png';
import ngc362 from '../../assets/dso/images/ngc362.jpg';
import ngc3628 from '../../assets/dso/images/ngc3628.jpg';
import ngc3766 from '../../assets/dso/images/ngc3766.jpg';
import ngc4038 from '../../assets/dso/images/ngc4038.jpg';
import ngc4039 from '../../assets/dso/images/ngc4039.jpg';
import ngc404 from '../../assets/dso/images/ngc404.jpg';
import ngc4147 from '../../assets/dso/images/ngc4147.png';
import ngc4244 from '../../assets/dso/images/ngc4244.jpg';
import ngc4449 from '../../assets/dso/images/ngc4449.jpg';
import ngc4565 from '../../assets/dso/images/ngc4565.jpeg';
import ngc457 from '../../assets/dso/images/ngc457.jpg';
import ngc4631 from '../../assets/dso/images/ngc4631.jpg';
import ngc4656 from '../../assets/dso/images/ngc4656.jpg';
import ngc4725 from '../../assets/dso/images/ngc4725.jpg';
import ngc4755 from '../../assets/dso/images/ngc4755.jpg';
import ngc4945 from '../../assets/dso/images/ngc4945.jpg';
import ngc5053 from '../../assets/dso/images/ngc5053.jpg';
import ngc5128 from '../../assets/dso/images/ngc5128.jpg';
import ngc5139 from '../../assets/dso/images/ngc5139.jpg';
import ngc5466 from '../../assets/dso/images/ngc5466.jpg';
import ngc5746 from '../../assets/dso/images/ngc5746.jpg';
import ngc5822 from '../../assets/dso/images/ngc5822.png';
import ngc5897 from '../../assets/dso/images/ngc5897.jpg';
import ngc604 from '../../assets/dso/images/ngc604.jpg';
import ngc6164 from '../../assets/dso/images/ngc6164.jpg';
import ngc6188 from '../../assets/dso/images/ngc6188.jpg';
import ngc6229 from '../../assets/dso/images/ngc6229.jpg';
import ngc6231 from '../../assets/dso/images/ngc6231.jpg';
import ngc6240 from '../../assets/dso/images/ngc6240.jpg';
import ngc6302 from '../../assets/dso/images/ngc6302.png';
import ngc6334 from '../../assets/dso/images/ngc6334.jpg';
import ngc6366 from '../../assets/dso/images/ngc6366.jpg';
import ngc6369 from '../../assets/dso/images/ngc6369.jpg';
import ngc6397 from '../../assets/dso/images/ngc6397.png';
import ngc6445 from '../../assets/dso/images/ngc6445.jpg';
import ngc6503 from '../../assets/dso/images/ngc6503.jpg';
import ngc6514 from '../../assets/dso/images/ngc6514.jpg';
import ngc6541 from '../../assets/dso/images/ngc6541.jpg';
import ngc6543 from '../../assets/dso/images/ngc6543.jpg';
import ngc6559 from '../../assets/dso/images/ngc6559.jpg';
import ngc6712 from '../../assets/dso/images/ngc6712.jpg';
import ngc6723 from '../../assets/dso/images/ngc6723.jpg';
import ngc6752 from '../../assets/dso/images/ngc6752.jpg';
import ngc6760 from '../../assets/dso/images/ngc6760.jpg';
import ngc6781 from '../../assets/dso/images/ngc6781.jpg';
import ngc6819 from '../../assets/dso/images/ngc6819.jpg';
import ngc6826 from '../../assets/dso/images/ngc6826.jpg';
import ngc6888 from '../../assets/dso/images/ngc6888.jpg';
import ngc6934 from '../../assets/dso/images/ngc6934.jpg';
import ngc6960 from '../../assets/dso/images/ngc6960.jpg';
import ngc7000 from '../../assets/dso/images/ngc7000.jpg';
import ngc7009 from '../../assets/dso/images/ngc7009.jpg';
import ngc7023 from '../../assets/dso/images/ngc7023.jpg';
import ngc7027 from '../../assets/dso/images/ngc7027.jpg';
import ngc7293 from '../../assets/dso/images/ngc7293.jpg';
import ngc7331 from '../../assets/dso/images/ngc7331.jpg';
import ngc7380 from '../../assets/dso/images/ngc7380.jpg';
import ngc752 from '../../assets/dso/images/ngc752.png';
import ngc7635 from '../../assets/dso/images/ngc7635.jpg';
import ngc7662 from '../../assets/dso/images/ngc7662.png';
import ngc7814 from '../../assets/dso/images/ngc7814.jpg';
import ngc869 from '../../assets/dso/images/ngc869.jpg';
import ngc884 from '../../assets/dso/images/ngc884.jpg';
import ngc891 from '../../assets/dso/images/ngc891.jpg';
import sh2_136 from '../../assets/dso/images/sh2-136.jpg';
import smc from '../../assets/dso/images/smc.jpg';
import stephans_quintet from '../../assets/dso/images/stephans_quintet.jpg';
import virgo_supercluster from '../../assets/dso/images/virgo_supercluster.jpg';
import mizor_and_alcor from '../../assets/dso/images/mizar_and_alcor.jpg';

// DSO name to image mapping
export const dsoImages: Record<string, string> = {
  'ic1805': ic1805,
  'ic2391': ic2391,
  'ic2574': ic2574,
  'ic2602': ic2602,
  'ic342': ic342,
  'ic434': ic434,
  'lmc': lmc,
  'm1': m1,
  'm10': m10,
  'm100': m100,
  'm101': m101,
  'm102': m102,
  'm103': m103,
  'm104': m104,
  'm105': m105,
  'm106': m106,
  'm107': m107,
  'm108': m108,
  'm109': m109,
  'm11': m11,
  'm110': m110,
  'm12': m12,
  'm13': m13,
  'm14': m14,
  'm15': m15,
  'm16': m16,
  'm17': m17,
  'm19': m19,
  'm2': m2,
  'm20': m20,
  'm21': m21,
  'm22': m22,
  'm23': m23,
  'm24': m24,
  'm25': m25,
  'm26': m26,
  'm27': m27,
  'm28': m28,
  'm29': m29,
  'm3': m3,
  'm30': m30,
  'm31': m31,
  'm32': m32,
  'm33': m33,
  'm34': m34,
  'm35': m35,
  'm36': m36,
  'm37': m37,
  'm38': m38,
  'm39': m39,
  'm4': m4,
  'm41': m41,
  'm42': m42,
  'm44': m44,
  'm45': m45,
  'm46': m46,
  'm47': m47,
  'm48': m48,
  'm49': m49,
  'm5': m5,
  'm50': m50,
  'm51': m51,
  'm52': m52,
  'm53': m53,
  'm55': m55,
  'm56': m56,
  'm57': m57,
  'm59': m59,
  'm6': m6,
  'm60': m60,
  'm61': m61,
  'm62': m62,
  'm63': m63,
  'm64': m64,
  'm65': m65,
  'm66': m66,
  'm67': m67,
  'm68': m68,
  'm69': m69,
  'm7': m7,
  'm70': m70,
  'm71': m71,
  'm72': m72,
  'm74': m74,
  'm75': m75,
  'm76': m76,
  'm77': m77,
  'm78': m78,
  'm79': m79,
  'm8': m8,
  'm80': m80,
  'm81': m81,
  'm82': m82,
  'm83': m83,
  'm84': m84,
  'm85': m85,
  'm86': m86,
  'm87': m87,
  'm89': m89,
  'm9': m9,
  'm90': m90,
  'm91': m91,
  'm92': m92,
  'm93': m93,
  'm95': m95,
  'm96': m96,
  'm97': m97,
  'm99': m99,
  'markarians_chain': markarians_chain,
  'ngc104': ngc104,
  'ngc1073': ngc1073,
  'ngc1275': ngc1275,
  'ngc1499': ngc1499,
  'ngc1851': ngc1851,
  'ngc188': ngc188,
  'ngc1931': ngc1931,
  'ngc2070': ngc2070,
  'ngc2169': ngc2169,
  'ngc2237': ngc2237,
  'ngc2261': ngc2261,
  'ngc2264': ngc2264,
  'ngc2301': ngc2301,
  'ngc2359': ngc2359,
  'ngc2362': ngc2362,
  'ngc2392': ngc2392,
  'ngc2403': ngc2403,
  'ngc2419': ngc2419,
  'ngc2438': ngc2438,
  'ngc2440': ngc2440,
  'ngc2451': ngc2451,
  'ngc2477': ngc2477,
  'ngc2516': ngc2516,
  'ngc2683': ngc2683,
  'ngc281': ngc281,
  'ngc2841': ngc2841,
  'ngc288': ngc288,
  'ngc300': ngc300,
  'ngc3132': ngc3132,
  'ngc3184': ngc3184,
  'ngc3293': ngc3293,
  'ngc3310': ngc3310,
  'ngc3372': ngc3372,
  'ngc3521': ngc3521,
  'ngc3532': ngc3532,
  'ngc3576': ngc3576,
  'ngc3603': ngc3603,
  'ngc362': ngc362,
  'ngc3628': ngc3628,
  'ngc3766': ngc3766,
  'ngc4038': ngc4038,
  'ngc4039': ngc4039,
  'ngc404': ngc404,
  'ngc4147': ngc4147,
  'ngc4244': ngc4244,
  'ngc4449': ngc4449,
  'ngc4565': ngc4565,
  'ngc457': ngc457,
  'ngc4631': ngc4631,
  'ngc4656': ngc4656,
  'ngc4725': ngc4725,
  'ngc4755': ngc4755,
  'ngc4945': ngc4945,
  'ngc5053': ngc5053,
  'ngc5128': ngc5128,
  'ngc5139': ngc5139,
  'ngc5466': ngc5466,
  'ngc5746': ngc5746,
  'ngc5822': ngc5822,
  'ngc5897': ngc5897,
  'ngc604': ngc604,
  'ngc6164': ngc6164,
  'ngc6188': ngc6188,
  'ngc6229': ngc6229,
  'ngc6231': ngc6231,
  'ngc6240': ngc6240,
  'ngc6302': ngc6302,
  'ngc6334': ngc6334,
  'ngc6366': ngc6366,
  'ngc6369': ngc6369,
  'ngc6397': ngc6397,
  'ngc6445': ngc6445,
  'ngc6503': ngc6503,
  'ngc6514': ngc6514,
  'ngc6541': ngc6541,
  'ngc6543': ngc6543,
  'ngc6559': ngc6559,
  'ngc6712': ngc6712,
  'ngc6723': ngc6723,
  'ngc6752': ngc6752,
  'ngc6760': ngc6760,
  'ngc6781': ngc6781,
  'ngc6819': ngc6819,
  'ngc6826': ngc6826,
  'ngc6888': ngc6888,
  'ngc6934': ngc6934,
  'ngc6960': ngc6960,
  'ngc7000': ngc7000,
  'ngc7009': ngc7009,
  'ngc7023': ngc7023,
  'ngc7027': ngc7027,
  'ngc7293': ngc7293,
  'ngc7331': ngc7331,
  'ngc7380': ngc7380,
  'ngc752': ngc752,
  'ngc7635': ngc7635,
  'ngc7662': ngc7662,
  'ngc7814': ngc7814,
  'ngc869': ngc869,
  'ngc884': ngc884,
  'ngc891': ngc891,
  'sh2-136': sh2_136,
  'smc': smc,
  'stephans_quintet': stephans_quintet,
  'virgo_supercluster': virgo_supercluster,
  'mizar_and_alcor': mizor_and_alcor,
};

export function getDsoImage(dsoId: string): string  {
  if (dsoImages[dsoId]) {
    return dsoImages[dsoId];
  }

  const normalizedId = dsoId.toUpperCase();
  for (const [key, value] of Object.entries(dsoImages)) {
    if (key.toUpperCase() === normalizedId) {
      return value;
    }
  }
  return dsoImages['m2'];
}
